import { ReactElement } from 'react';
import { Button } from '@components/button/Button';
import { useI18nContext } from '@i18n/i18n-react';
import { useAuth } from '@providers/AuthProvider';
import { WorkspaceSwitchContainer } from './WorkspaceSwitchPrompt.style';

/** Escape hatch on the maintenance screen: offers a blocked user the other workspaces they can switch to. */
export function WorkspaceSwitchPrompt(): ReactElement | null {
    const { LL } = useI18nContext();
    const { organization, tenant, changeTenant } = useAuth();

    const candidates = (organization?.tenants ?? [])
        .filter((t) => t.name !== tenant)
        .sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base', numeric: true }));

    if (candidates.length === 0) {
        return null;
    }

    return (
        <WorkspaceSwitchContainer>
            <p>{LL.OTHER_WORKSPACES_AVAILABLE()}</p>
            {candidates.map((t) => (
                <Button key={t.name} title={t.name} onClick={() => changeTenant(t.name)} />
            ))}
        </WorkspaceSwitchContainer>
    );
}
